export default {
  install(Vue) {
    Vue.prototype.get_department = async function() {
      const api = `${window.endpoints.api}/BasicInformation/department`;
      const response = await this.$http.get(api);
      return response.data;
    };
  },
};